import React,{useState} from 'react';
import LeftRightBat from "./LeftRightBat";
import PitchingCourse from "./PitchingCourse";
import BallSpeed from "./BallSpeed";
import PitchType from "./PitchType";
import HittingDirection from "./HittingDirection";
import HittingProperty from "./HittingProperty";
import Count from "./Count";
import Runner from "./Runner";
import ScoringRunner from "./ScoringRunner";
import PointDifference from "./PointDifference";
import Inning from "./Inning";
import AtBat from "./AtBat";
import InningTopBatter from "./InningTopBatter";
import NumberOfPitcherAtBat from "./NumberOfPitchesAtBat";
import BattingOrder from "./BattingOrder";
import DefensivePosition from "./DefensivePosition";
import StarterRelief from "./StarterRelief";
import {ANALYSIS} from "../constant";
import {useSelector} from "react-redux";
import '../styles.scss';


function Index(props) {
    const {onChange} = props;
    const dataSearch = useSelector(state => state.detailSearch);
    return (
        <div className="analysis-item">
            <h3 className='navbar-item' style={{ marginBottom: 3, borderBottom: '1px solid #ddd', paddingBottom: 26}}>分析項目</h3>
            <div className='inner-item-group'>
                <LeftRightBat selected={dataSearch[ANALYSIS.LEFT_RIGHT_BAT]}
                              onChange={(values) => onChange(values, ANALYSIS.LEFT_RIGHT_BAT)}/>
                <PitchingCourse selected={dataSearch[ANALYSIS.PITCHING_COURSE]}
                                onChange={(values) => onChange(values, ANALYSIS.PITCHING_COURSE)}/>
                <BallSpeed selected={dataSearch[ANALYSIS.BALL_SPEED]}
                           onChange={(values) => onChange(values, ANALYSIS.BALL_SPEED)}/>
                <PitchType selected={dataSearch[ANALYSIS.PITCH_TYPE]}
                           onChange={(values) => onChange(values, ANALYSIS.PITCH_TYPE)}/>
                {dataSearch.type === ANALYSIS.TYPE_BATTER &&
                    <HittingDirection selected={dataSearch[ANALYSIS.HITTING_DIRECTION]}
                                      onChange={(values) => onChange(values, ANALYSIS.HITTING_DIRECTION)}/>
                }
                <HittingProperty selected={dataSearch[ANALYSIS.HITTING_PROPERTY]}
                                 onChange={(values) => onChange(values, ANALYSIS.HITTING_PROPERTY)}/>
                <Count selected={dataSearch[ANALYSIS.COUNT]}
                       onChange={(values) => onChange(values, ANALYSIS.COUNT)}/>
                <Runner selected={dataSearch[ANALYSIS.RUNNER]}
                        onChange={(values) => onChange(values, ANALYSIS.RUNNER)}/>
                <ScoringRunner selected={dataSearch[ANALYSIS.SCORING_RUNNER]}
                               onChange={(values) => onChange(values, ANALYSIS.SCORING_RUNNER)}/>
                <PointDifference selected={dataSearch[ANALYSIS.POINT_DIFFERENCE]}
                                 onChange={(values) => onChange(values, ANALYSIS.POINT_DIFFERENCE)}/>
                <Inning selected={dataSearch[ANALYSIS.INNING]}
                        onChange={(values) => onChange(values, ANALYSIS.INNING)}/>
                {dataSearch.type === ANALYSIS.TYPE_BATTER &&
                    <AtBat selected={dataSearch[ANALYSIS.AT_BAT]}
                           onChange={(values) => onChange(values, ANALYSIS.AT_BAT)}/>
                }
                <InningTopBatter selected={dataSearch[ANALYSIS.INNING_TOP_BATTER]}
                                 onChange={(values) => onChange(values, ANALYSIS.INNING_TOP_BATTER)}/>
                {dataSearch.type === ANALYSIS.TYPE_BATTER &&
                    <NumberOfPitcherAtBat selected={dataSearch[ANALYSIS.NUMBER_OF_PITCHER_AT_BAT]}
                                          onChange={(values) => onChange(values, ANALYSIS.NUMBER_OF_PITCHER_AT_BAT)}/>
                }
                <BattingOrder selected={dataSearch[ANALYSIS.BATTING_ORDER]}
                              onChange={(values) => onChange(values, ANALYSIS.BATTING_ORDER)}/>
                {dataSearch.type === ANALYSIS.TYPE_BATTER &&
                    <DefensivePosition selected={dataSearch[ANALYSIS.DEFENSIVE_POSITION]}
                                       onChange={(values) => onChange(values, ANALYSIS.DEFENSIVE_POSITION)}/>
                }
                {dataSearch.type === ANALYSIS.TYPE_PITCHER &&
                    <StarterRelief selected={dataSearch[ANALYSIS.STARTER_RELIEF]}
                                   onChange={(values) => onChange(values, ANALYSIS.STARTER_RELIEF)}/>
                }
            </div>
        </div>
    );
}

export default Index;
